import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DashboardLayout, Card, Button } from '../components';
import { adminApi } from '../services/api';

export function AdminSessionSettings() {
  const { t } = useTranslation();
  const [minutes, setMinutes] = useState('15');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [status, setStatus] = useState<'saved' | 'error' | null>(null);
  useEffect(() => {
    adminApi.getSessionSettings().then(settings => setMinutes(String(settings.idleTimeoutMinutes)))
      .catch(() => setStatus('error')).finally(() => setLoading(false));
  }, []);
  const save = async (event: React.FormEvent) => {
    event.preventDefault();
    setSaving(true);
    setStatus(null);
    try {
      const settings = await adminApi.updateSessionSettings(Number(minutes));
      setMinutes(String(settings.idleTimeoutMinutes));
      setStatus('saved');
    } catch { setStatus('error'); } finally { setSaving(false); }
  };
  const valid = Number.isInteger(Number(minutes)) && Number(minutes) >= 1 && Number(minutes) <= 120;
  return <DashboardLayout>
    <h1 className="h4 mb-4">{t('adminSessionSettings.title')}</h1>
    <Card>
      <form onSubmit={save}>
        <p>{t('adminSessionSettings.description')}</p>
        <div className="row g-3">
          <div className="col-12 col-md-6 col-xl-4">
            <label className="form-label" htmlFor="idle-timeout">{t('adminSessionSettings.minutes')}</label>
            <input id="idle-timeout" type="number" inputMode="numeric" min={1} max={120} step={1} required className="form-control" value={minutes} disabled={loading || saving} onChange={event => { setMinutes(event.target.value); setStatus(null); }} aria-describedby="idle-timeout-help" />
          </div>
        </div>
        <p className="text-muted small mt-2" id="idle-timeout-help">{t('adminSessionSettings.help')}</p>
        <p className="text-muted small">{t('adminSessionSettings.returnHelp')}</p>
        {status && <p role="status" className={status === 'saved' ? 'text-success' : 'text-danger'}>{t(`adminSessionSettings.${status}`)}</p>}
        <div className="d-grid d-sm-flex">
          <Button type="submit" disabled={loading || saving || !valid}>{t(saving ? 'adminSessionSettings.saving' : 'adminSessionSettings.save')}</Button>
        </div>
      </form>
    </Card>
  </DashboardLayout>;
}
